import React, {Fragment} from 'react';
import {connect} from "src/store";
import ModalEditor from "../editors/ModalEditor";
import {setPos, setTill, setLocationSection, setClient} from '../../actions';
import Icon from "../form/Icon";
import Button from "../form/Button";
import Select from "../form/Select";
import isEqual from "lodash-es/isEqual";
import {optionsTemplate} from "../../utils/formatters";
import {Tooltip} from "react-tippy";
import {loadComponent} from "../../utils/components";
import debounce from "../../utils/debounce";

const Li = (props) => <Tooltip {...props} style={{...(props.style || {}), display: undefined}}>{props.children}</Tooltip>;

class Pos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {pos: props.context?.pos, isLoading: false};
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.context.pos, this.props.context.pos)) {
            this.setState({pos: this.props.context?.pos});
        }
        if (!isEqual((prevProps.user || {}).id, (this.props.user || {}).id)) {
            this.editor && this.editor.hide();
        }
    }

    checkPermission = () => {
        return (this.props.context?.controls || []).indexOf("pos_id") !== -1;
    }

    onClick = async (e) => {
        e && e.preventDefault();
        if (!this.checkPermission()) {
            return;
        }
        this.setState({pos: this.props.context?.pos});
        this.editor && this.editor.focus();
    }

    saveForm = async (e) => {
        e && e.preventDefault();
        this.setState({isLoading: true}, async () => {
            await this.props.setPos(this.state.pos.id);
            this.editor && this.editor.hide();
            this.setState({isLoading: false});
        });
    }

    render() {
        if (!(this.props.user.hasPermission("view_pos") || this.checkPermission())) {
            return null;
        }
        let posFilter = null;
        if (this.props.user.partner) {
            posFilter = [{field: "partner", value: this.props.user.partner.partner_id}];
        }
        return <Fragment>
            <Li title="Eladás helye" tag="li">
                <a {...{href: !this.checkPermission() ? null : "#"}} onClick={this.onClick}>
                    <span className="pos"> <Icon lib="fas" name="store-alt" className="d-none d-md-inline" /> {this.props.context?.pos ? this.props.context?.pos?.name : null}</span>
                    {!this.props.context?.pos?.id && <span className="label label-danger">!</span>}
                </a>
            </Li>
            <ModalEditor
                {...this.props}
                isLoading={this.state.isLoading}
                pristineForm={() => {
                    this.editor && this.editor.hide();
                }}
                size="small"
                ref={(editor) => this.editor = editor}
                theme="default"
                header={<Fragment><Icon lib="fas" name="store-alt" /> Eladási hely</Fragment>}
                footer={[
                    <Button
                        key="0"
                        color="primary"
                        className="pull-right"
                        disabled={!this.state.pos?.id || this.props.context?.pos?.id + "" === "" + this.state.pos?.id || this.state.isLoading || !this.checkPermission()}
                        onClick={this.saveForm}
                    >
                        Bejelentkezés
                    </Button>
                ]}
            >
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            objectValue={true}
                            disabled={this.state.isLoading || !this.checkPermission()}
                            name="pos"
                            component="PointOfSale"
                            labelKey="name"
                            valueKey="id"
                            filter={posFilter}
                            storeType="local"
                            value={this.state.pos}
                            saveChanges={(field, pos) => this.setState({pos})}
                            label={false}
                        />
                    </div>
                </div>
            </ModalEditor>
        </Fragment>;
    }
}

class Till extends React.Component {

    constructor(props) {
        super(props);
        this.state = {till: props.context?.till, isLoading: false, tills: []};
        this.loadAvailableTills = debounce(() => {
            this.loadAvailableTillsRequest && this.loadAvailableTillsRequest.abort();
            this.setState({tills: []});
            if (this?.props.context?.pos?.id) {
                this.loadAvailableTillsRequest = loadComponent("componentlist", {
                    component: "Till",
                    filter: [{field: "pos", value: this.props.context?.pos?.id}]
                });
                this.loadAvailableTillsRequest.then((data) => {
                    this.setState({tills: data.items});
                });
                this.loadAvailableTillsRequest.catch(() => {
                    this.setState({tills: []});
                });
            } else {
                this.setState({tills: []});
            }
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.context.till, this.props.context.till)) {
            this.setState({till: this.props.context?.till});
        }
        if (!isEqual(prevProps?.user?.id, this.props.user?.id)) {
            this.editor && this.editor.hide();
        }
        if (!isEqual(this?.props.context?.pos?.id, prevProps?.context?.pos?.id)) {
            this.loadAvailableTills();
        }
    }

    checkPermission = () => {
        return (this.props.context?.controls || []).indexOf("till_id") !== -1;
    }

    onClick = async (e) => {
        e && e.preventDefault();
        if (!this.checkPermission()) {
            return;
        }
        this.setState({till: this.props.context?.till});
        this.editor && this.editor.focus();
    }

    saveForm = async (e) => {
        e && e.preventDefault();
        this.setState({isLoading: true}, async () => {
            await this.props.setTill(this.state.till?.id);
            this.editor && this.editor.hide();
            this.setState({isLoading: false});
        });
    }

    componentDidMount() {
        this.loadAvailableTills();
    }

    componentWillUnmount() {
        this.loadAvailableTillsRequest && this.loadAvailableTillsRequest.abort();
        this.loadAvailableTills.cancel();
    }

    render() {
        if (!this.state.tills.length || !(this.props.user.hasPermission("view_till") || this.checkPermission())) {
            return null;
        }
        return <Fragment>
            <Li title="Pénztár" tag="li">
                <a {...{href: !this.checkPermission() ? null : "#"}} onClick={this.onClick}>
                    <span className="till"> <Icon lib="fa" name="cash-register" className="d-none d-md-inline" /> {this.props.context?.till?.id ? this.props.context?.till?.displayname : null}</span>
                    {!this.props.context?.till?.id && <span className="label label-danger">!</span>}
                </a>
            </Li>
            <ModalEditor
                {...this.props}
                isLoading={this.state.isLoading}
                pristineForm={() => {
                    this.editor && this.editor.hide();
                }}
                size="small"
                ref={(editor) => this.editor = editor}
                theme="default"
                header={<Fragment><Icon lib="fa" name="cash-register" /> Pénztár</Fragment>}
                footer={[
                    <Button
                        key="0"
                        color="primary"
                        className="pull-right"
                        disabled={this.props.context?.till?.id + "" === "" + this.state.till?.id || this.state.isLoading || !this.checkPermission()}
                        onClick={this.saveForm}
                    >
                        Bejelentkezés
                    </Button>
                ]}
            >
                <div className="row form-row">
                    <div className="col-md-12">
                        {
                            this.props.context?.pos?.id &&
                            <Select
                                filter={[{field: "pos", value: this.props.context?.pos?.id}]}
                                objectValue={true}
                                disabled={this.state.isLoading || !this.checkPermission()}
                                name="till"
                                component="Till"
                                labelKey="displayname"
                                valueKey="id"
                                storeType="local"
                                isClearable={true}
                                value={this.state.till}
                                saveChanges={(field, till) => this.setState({till})}
                                label={false}
                            />
                        }
                    </div>
                </div>
            </ModalEditor>
        </Fragment>;
    }
}

class LocationSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {location_section: props.context?.location_section, isLoading: false, location_sections: []};
        this.loadAvailableLocationSections = debounce(() => {
            this.loadAvailableLocationSectionsRequest && this.loadAvailableLocationSectionsRequest.abort();
            if (!this.checkPermission()) {
                this.setState({location_sections: []});
                return;
            }
            if (this.props.context?.location?.id) {
                this.loadAvailableLocationSectionsRequest = loadComponent("componentlist", {
                    component: "LocationSection",
                    filter: [
                        {field: "parent_type", value: "location"},
                        {field: "parent_id", value: this.props.context?.location?.id},
                    ]
                });
                this.loadAvailableLocationSectionsRequest.then((data) => {
                    this.setState({location_sections: data.items});
                });
                this.loadAvailableLocationSectionsRequest.catch(() => {
                    this.setState({location_sections: []});
                });
            } else {
                this.setState({location_sections: []});
            }
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.context?.location_section, this.props.context?.location_section)) {
            this.setState({location_section: this.props.context?.location_section});
        }
        if (!isEqual(prevProps.user?.id, this.props.user?.id)) {
            this.editor && this.editor.hide();
        }
        if (!isEqual(this.props.context?.location?.id, prevProps.context?.location?.id)) {
            this.loadAvailableLocationSections();
        }
    }

    checkPermission = () => {
        return (this.props.context?.controls || []).indexOf("location_section_id") !== -1;
    }

    onClick = async (e) => {
        e && e.preventDefault();
        if (!this.checkPermission()) {
            return;
        }
        this.setState({location_section: this.props.context?.location_section});
        this.editor && this.editor.focus();
    }

    saveForm = async (e) => {
        e && e.preventDefault();
        this.setState({isLoading: true}, async () => {
            await this.props.setLocationSection(this.state.location_section?.id);
            this.editor && this.editor.hide();
            this.setState({isLoading: false});
        });
    }

    componentDidMount() {
        this.loadAvailableLocationSections();
    }

    componentWillUnmount() {
        this.loadAvailableLocationSectionsRequest && this.loadAvailableLocationSectionsRequest.abort();
        this.loadAvailableLocationSections.cancel();
    }

    render() {
        if (!this.state.location_sections.length || !(this.props.user.hasPermission("view_location_section") || this.checkPermission())) {
            return null;
        }
        return <Fragment>
            <Li title="Egység" tag="li">
                <a {...{href: !this.checkPermission() ? null : "#"}} onClick={this.onClick}>
                    <span className="location_section"> <Icon lib="fa" name="map-marker" className="d-none d-md-inline" /> {this.props.context?.location_section?.id ? this.props.context?.location_section?.name : null}</span>
                    {!this.props.context?.location_section?.id && <span className="label label-danger">!</span>}
                </a>
            </Li>
            <ModalEditor
                {...this.props}
                isLoading={this.state.isLoading}
                pristineForm={() => {
                    this.editor && this.editor.hide();
                }}
                size="small"
                ref={(editor) => this.editor = editor}
                theme="default"
                header={<Fragment><Icon lib="fa" name="map-marker" /> Egység</Fragment>}
                footer={[
                    <Button
                        key="0"
                        color="primary"
                        className="pull-right"
                        disabled={this.props.context?.location_section?.id + "" === "" + this.state.location_section?.id || this.state.isLoading || !this.checkPermission()}
                        onClick={this.saveForm}
                    >
                        Bejelentkezés
                    </Button>
                ]}
            >
                <div className="row form-row">
                    <div className="col-md-12">
                        {
                            this.props.context?.location?.id &&
                            <Select
                                filter={[
                                    {field: "parent_type", value: "location"},
                                    {field: "parent_id", value: this.props.context?.location?.id},
                                ]}
                                objectValue={true}
                                disabled={this.state.isLoading || !this.checkPermission()}
                                name="location_section"
                                component="LocationSection"
                                labelKey="name"
                                valueKey="id"
                                storeType="local"
                                isClearable={true}
                                value={this.state.location_section}
                                saveChanges={(field, location_section) => this.setState({location_section})}
                                label={false}
                            />
                        }
                    </div>
                </div>
            </ModalEditor>
        </Fragment>;
    }
}

class Partner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {client: props.context?.client, isLoading: false};
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.context.client, this.props.context.client)) {
            this.setState({client: this.props.context?.client});
        }
        if (!isEqual((prevProps.user || {}).id, (this.props.user || {}).id)) {
            this.editor && this.editor.hide();
        }
    }

    checkPermission = () => {
        return (this.props.context?.controls || []).indexOf("client_id") !== -1;
    }

    onClick = async (e) => {
        e && e.preventDefault();
        if (!this.checkPermission()) {
            return;
        }
        this.setState({client: this.props.context?.client});
        this.editor && this.editor.focus();
    }

    saveForm = async (e) => {
        e && e.preventDefault();
        this.setState({isLoading: true}, async () => {
            await this.props.setClient(this.state.client.partner_id);
            this.editor && this.editor.hide();
            this.setState({isLoading: false});
        });
    }

    render() {
        if (!(this.props.user.hasPermission("view_client") || this.checkPermission())) {
            return null;
        }
        return <Fragment>
            <Li title="Partner" tag="li">
                <a {...{href: !this.checkPermission() ? null : "#"}} onClick={this.onClick}>
                    <span className="partner"> <Icon lib="fas" name="user" className="d-none d-md-inline" /> {this.props.context?.client && this.props.context?.client?.name}</span>
                    {!this.props.context?.client?.partner_id && <span className="label label-danger">!</span>}
                </a>
            </Li>
            <ModalEditor
                {...this.props}
                isLoading={this.state.isLoading}
                pristineForm={() => {
                    this.editor && this.editor.hide();
                }}
                size="small"
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Partner"
                footer={[
                    <Button
                        key="0"
                        color="primary"
                        className="pull-right"
                        disabled={!this.state.client?.partner_id || this.props.context?.client?.partner_id + "" === "" + this.state.client?.partner_id || this.state.isLoading || !this.checkPermission()}
                        onClick={this.saveForm}
                    >
                        Bejelentkezés
                    </Button>
                ]}
            >
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            objectValue={true}
                            disabled={this.state.isLoading || !this.checkPermission()}
                            name="client"
                            component="partner"
                            labelKey="name"
                            valueKey="partner_id"
                            optionsTemplate={optionsTemplate("partner")}
                            storeType="remote"
                            value={this.state.client}
                            saveChanges={(field, client) => this.setState({client})}
                            label="Partner"
                        />
                    </div>
                </div>
            </ModalEditor>
        </Fragment>;
    }
}

const MainContextMenu = (props) => {
    return <Fragment>
        <Pos {...props} />
        {/*<Till {...props} />*/}
        <LocationSection {...props} />
        <Partner {...props} />
    </Fragment>
}

const ConnectedMainContextMenu = connect((state) => {
    return {
        context: state.app.context,
        user: state.app.user
    }
}, {setPos, setTill, setLocationSection, setClient})(MainContextMenu);

export default ConnectedMainContextMenu;
